/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
} from './FacilityServiceAreaStatus';

/**
 * 
 * @export
 * @interface BulkUpdateFacilityServiceAreasRequest
 */
export interface BulkUpdateFacilityServiceAreasRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateFacilityServiceAreasRequest
     */
    ids: Array<string>;
    /**
     * 
     * @type {FacilityServiceAreaStatus}
     * @memberof BulkUpdateFacilityServiceAreasRequest
     */
    status?: FacilityServiceAreaStatus;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateFacilityServiceAreasRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the BulkUpdateFacilityServiceAreasRequest interface.
 */
export function instanceOfBulkUpdateFacilityServiceAreasRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ids" in value;

    return isInstance;
}

export function BulkUpdateFacilityServiceAreasRequestFromJSON(json: any): BulkUpdateFacilityServiceAreasRequest {
    return BulkUpdateFacilityServiceAreasRequestFromJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateFacilityServiceAreasRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'status': !exists(json, 'status') ? undefined : FacilityServiceAreaStatusFromJSON(json['status']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function BulkUpdateFacilityServiceAreasRequestToJSON(value?: BulkUpdateFacilityServiceAreasRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ids': value.ids,
        'status': FacilityServiceAreaStatusToJSON(value.status),
        'notes': value.notes,
    };
}

